import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colorTokens, typographyTokens } from '../../app/designTokens';
import { RegisterSectionCard } from './RegisterSectionCard';
import { REGISTER_LABEL_SX, REGISTER_VALUE_SX } from './registerSurfaces';

const { semantic } = colorTokens;

function formatUpdatedAt(value, locale) {
  if (!value) {
    return null;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed.toLocaleString(locale);
}

/** Steps 5–6 — provisioning run metadata from the public launch status payload. */
export function ProvisioningRunCard({ status, progress, testId = 'register-launch-run' }) {
  const { t, i18n } = useTranslation(['onboarding', 'common']);
  const updatedAt = formatUpdatedAt(status?.updated_at, i18n.language);

  return (
    <RegisterSectionCard
      title={t('onboarding:register.wizard.provisioning_run_title')}
      testId={testId}
    >
      <Stack spacing={1}>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Typography sx={REGISTER_LABEL_SX}>
            {t('onboarding:register.wizard.provisioning_run_reference')}
          </Typography>
          <Typography
            data-testid="register-launch-public-id"
            sx={{
              ...REGISTER_VALUE_SX,
              fontFamily: typographyTokens.fontFamilyMono,
              wordBreak: 'break-all',
              textAlign: 'right',
            }}
          >
            {status?.public_id || t('common:empty_value')}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Typography sx={REGISTER_LABEL_SX}>
            {t('onboarding:register.launch_status_label')}
          </Typography>
          <Typography
            data-testid="register-launch-run-status"
            data-status={status?.status}
            sx={REGISTER_VALUE_SX}
          >
            {t(`onboarding:register.launch_status.${status?.status}`, status?.status)}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Typography sx={REGISTER_LABEL_SX}>
            {t('onboarding:register.launch_overall_progress')}
          </Typography>
          <Typography sx={REGISTER_VALUE_SX}>{`${progress}%`}</Typography>
        </Stack>
        {updatedAt ? (
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <Typography sx={REGISTER_LABEL_SX}>
              {t('onboarding:register.wizard.provisioning_run_updated')}
            </Typography>
            <Typography sx={{ ...REGISTER_VALUE_SX, textAlign: 'right' }}>{updatedAt}</Typography>
          </Stack>
        ) : null}
        {status?.failure_code ? (
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <Typography sx={REGISTER_LABEL_SX}>
              {t('onboarding:register.wizard.provisioning_run_failure')}
            </Typography>
            <Typography
              data-testid="register-launch-failure-code"
              sx={{ ...REGISTER_VALUE_SX, color: semantic.error, textAlign: 'right' }}
            >
              {status.failure_code}
            </Typography>
          </Stack>
        ) : null}
      </Stack>
    </RegisterSectionCard>
  );
}

export default ProvisioningRunCard;
